import { InbuildsA330Seo } from "../../../content/templateMarketing/inibuilds-a330-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import a330Image from "../../images/templates/inibuilds-a330.png";

export const a330Template: AircraftAddonTemplate = {
  type: "aircraft",
  title: "Inibuilds A330",
  id: "inibuilds-a330",
  platforms: ["msfs"],
  image: a330Image,
  infoMarketingBlurb: InbuildsA330Seo,
  content: [
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Safety Check",
        },
        {
          item: "Parking Brake",
          setting: "Set",
        },
        {
          item: "Speed Brake Lever",
          setting: "Retract",
        },
        {
          item: "Flaps Lever",
          setting: "Up",
        },
        {
          item: "Engine Start Selector",
          setting: "Norm",
        },
        {
          item: "Engine Master 1 & 2",
          setting: "Off",
        },
        {
          item: "Thrust Levers",
          setting: "Idle",
        },
        {
          item: "Weather Radar SYS & PWS",
          setting: "Off",
        },
        {
          item: "Landing Gear Lever",
          setting: "Down",
        },
        {
          header: "Power Up",
        },
        {
          item: "Battery 1 / 2",
          setting: "On",
        },
        {
          item: "APU Battery",
          setting: "On",
        },
        {
          item: "External Power",
          setting: "As Req / On",
        },
        {
          item: "Nav & Logo Lights",
          setting: "On",
        },
        {
          item: "APU Fire Test",
          setting: "Perform",
        },
        {
          item: "APU",
          setting: "Start",
        },
        {
          item: "APU Bleed",
          setting: "On",
        },
        {
          item: "External Power",
          setting: "Off",
        },
        {
          header: "Overhead Panel",
        },
        {
          item: "ADIRS",
          setting: "Nav",
        },
        {
          item: "Exterior Lights",
          setting: "As Req",
        },
        {
          item: "Passenger Signs",
          setting: "As Req",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Arm",
        },
        {
          item: "Fuel Pumps",
          setting: "On",
        },
        {
          item: "Engine Fire Test",
          setting: "Perform",
        },
        {
          item: "Overhead Panel",
          setting: "No White Lights",
        },
        {
          header: "Glare Shield Panel",
        },
        {
          item: "Altimeter (EFIS & STBY)",
          setting: "Set",
        },
        {
          item: "EFIS - FD Button",
          setting: "On (Both Sides)",
        },
        {
          item: "EFIS - ND Mode & Range",
          setting: "As Req",
        },
        {
          item: "FCU - SPD",
          setting: "Check Dashed",
        },
        {
          item: "FCU - HDG",
          setting: "Check Dashed",
        },
        {
          item: "FCU - ALT SEL",
          setting: "Set Cleared or Cruise Altitude",
        },
        {
          item: "PFD - FMA",
          setting: "Check",
        },
      ],
    },
    {
      title: "Cockpit Preparation (Contd)",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Main Panel & Pedestal",
        },
        {
          item: "Oxygen Mask",
          setting: "Test",
        },
        {
          item: "Display Brightnesses",
          setting: "As Req",
        },
        {
          item: "Standby Instruments & Clock",
          setting: "Check & Set",
        },
        {
          item: "Anti-Skid & N/W Steering",
          setting: "On",
        },
        {
          item: "Landing Gear",
          setting: "Down & 3 Green",
        },
        {
          item: "Brake Accu Pressure",
          setting: "Check Green",
        },
        {
          item: "Transponder",
          setting: "Stby, Alt On & Squawk Set",
        },
        {
          item: "TCAS",
          setting: "All & Stby",
        },
      ],
    },
    {
      title: "Before Engine Start",
      roles: ["beforeFlightStart", "beforePushback", "beforeEngineStart"],
      content: [
        {
          item: "Parking Brake",
          setting: "On",
        },
        {
          item: "Windows / Doors",
          setting: "Closed",
        },
        {
          item: "Cockpit Door",
          setting: "Locked",
        },
        {
          item: "APU",
          setting: "Verify On",
        },
        {
          item: "APU Bleed",
          setting: "Verify On",
        },
        {
          item: "External Power",
          setting: "Verify Off",
        },
        {
          item: "Passenger Signs",
          setting: "On / Auto",
        },
        {
          item: "Beacon",
          setting: "On",
        },
      ],
    },
    {
      title: "Pushback & Engine Start",
      roles: ["engineStart"],
      content: [
        {
          item: "Throttles",
          setting: "Verify Idle",
        },
        {
          item: "Engine Start Selector",
          setting: "IGN / Start",
        },
        {
          item: "ENG 1 Master Switch",
          setting: "On",
        },
        {
          item: "ENG 1 Parameters",
          setting: "Monitor",
        },
        {
          item: "ENG 2 Master Switch",
          setting: "On",
        },
        {
          item: "ENG 2 Parameters",
          setting: "Monitor",
        },
        {
          item: "Engine Start Selector",
          setting: "As Req / Norm",
        },
      ],
    },
    "page-break",
    {
      title: "After Start / Before Taxi",
      roles: ["afterEngineStart", "beforeTaxi", "taxi"],
      content: [
        {
          item: "APU Bleed",
          setting: "Off",
        },
        {
          item: "APU Master",
          setting: "Off",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "Auto Brake",
          setting: "Max",
        },
        {
          item: "Engine Start Selector",
          setting: "As Req / Norm",
        },
        {
          item: "Flaps",
          setting: "Set For Takeoff",
        },
        {
          item: "Ground Spoilers",
          setting: "Arm",
        },
        {
          item: "Rudder & Aileron Trim",
          setting: "Zero",
        },
        {
          item: "Pitch Trim",
          setting: "As Calculated",
        },
        {
          item: "Flight Controls",
          setting: "Free & Full Movement",
        },
        {
          item: "ECAM Status",
          setting: "Check",
        },
        {
          header: "Taxi Out",
        },
        {
          item: "Nose Lights",
          setting: "Taxi",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "As Req",
        },
        {
          item: "Strobe Lights",
          setting: "Auto",
        },
        {
          item: "Transponder",
          setting: "Auto",
        },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        {
          header: "Holding Short",
        },
        {
          item: "Packs",
          setting: "As Req",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "FCU Panel",
          setting: "Check",
        },
        {
          item: "Terrain on ND",
          setting: "As Req",
        },
        {
          item: "Auto Brake",
          setting: "Max",
        },
        {
          item: "Weather Radar",
          setting: "As Req",
        },
        {
          item: "Predictive Windshear",
          setting: "On",
        },
        {
          item: "Engine Start Selector",
          setting: "As Req",
        },
        {
          item: "Ground Spoilers",
          setting: "Verify Armed",
        },
        {
          item: "Flaps",
          setting: "Verify Set",
        },
        {
          item: "TCAS",
          setting: "TA/RA",
        },
        {
          item: "TO Config Test",
          setting: "No Blue",
        },
        {
          header: "Entering the Runway",
        },
        {
          item: "Strobe Lights",
          setting: "On",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Nose Lights",
          setting: "Takeoff",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "On",
        },
      ],
    },
    {
      title: "After Takeoff",
      roles: ["climbOut"],
      content: [
        {
          item: "Landing Gear",
          setting: "Verify Up",
        },
        {
          item: "Flaps",
          setting: "Verify Retracted",
        },
        {
          item: "Ground Spoilers",
          setting: "Disarm",
        },
        {
          item: "Engine Start Selector",
          setting: "As Req",
        },
        {
          item: "Auto Brake",
          setting: "Off",
        },
        {
          item: "Packs",
          setting: "On",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          header: "Passing Transition Altitude",
        },
        {
          item: "Altimeters",
          setting: "Set STD",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "Nose Lights",
          setting: "Off",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "Off",
        },
        {
          item: "Terrain On ND",
          setting: "Off",
        },
        {
          item: "Passenger Signs",
          setting: "As Req",
        },
      ],
    },
    {
      title: "Cruise",
      roles: ["cruise"],
      content: [
        {
          item: "Passenger Signs",
          setting: "As Req",
        },
        {
          item: "Pressurization",
          setting: "Check",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "Flight Plan Progress & EFOB",
          setting: "Monitor",
        },
        {
          item: "Top of Descent",
          setting: "Cross Check",
        },
      ],
    },
    {
      title: "Descent Preparation",
      roles: ["beforeDescent"],
      content: [
        {
          item: "Weather & Active Runway",
          setting: "Obtain",
        },
        {
          item: "Approach & Landing",
          setting: "Obtain & Review",
        },
        {
          item: "Auto Brake",
          setting: "Set",
        },
        {
          item: "Fuel Quantity",
          setting: "Check",
        },
        {
          item: "Passenger Signs",
          setting: "As Req",
        },
      ],
    },
    "page-break",
    {
      title: "Descent",
      roles: ["descent"],
      content: [
        {
          header: "Top of Descent",
        },
        {
          item: "Descent",
          setting: "Initiate",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "Engine Start Selector",
          setting: "As Req",
        },
        {
          item: "Passenger Signs",
          setting: "As Req",
        },
        {
          header: "Passing Transition Level",
        },
        {
          item: "Altimeters",
          setting: "Set",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Nose Lights",
          setting: "Takeoff",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "On",
        },
        {
          item: "Passenger Signs",
          setting: "On",
        },
      ],
    },
    {
      title: "Approach",
      roles: ["approach", "landing"],
      content: [
        {
          item: "Terrain on ND",
          setting: "As Req",
        },
        {
          item: "Altimeters",
          setting: "Check Set",
        },
        {
          item: "Auto Brake",
          setting: "Check Set",
        },
        {
          item: "Engine Start Selectors",
          setting: "As Req",
        },
        {
          header: "Approach Checklist",
        },
        {
          item: "Briefing",
          setting: "Confirmed",
        },
        {
          item: "ECAM Status",
          setting: "Checked",
        },
        {
          item: "Seat Belts",
          setting: "On",
        },
        {
          item: "Baro Ref",
          setting: "____ Set",
        },
        {
          item: "Minimums",
          setting: "____ Set",
        },
        {
          header: "Landing Checklist",
        },
        {
          item: "Cabin Crew",
          setting: "Advised",
        },
        {
          item: "Auto Brake",
          setting: "Verify Set",
        },
        {
          item: "Ground Spoilers",
          setting: "Verify Armed",
        },
        {
          item: "Landing Gear",
          setting: "Down & 3 Green",
        },
        {
          item: "Flaps",
          setting: "Verify Set",
        },
        {
          item: "ECAM Memo",
          setting: "Landing No Blue",
        },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        {
          item: "Strobe Lights",
          setting: "Auto",
        },
        {
          item: "Landing Lights",
          setting: "Off",
        },
        {
          item: "Nose Lights",
          setting: "Taxi",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "As Req",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "APU",
          setting: "As Req / Start",
        },
        {
          item: "Terrain On ND",
          setting: "Off",
        },
        {
          item: "Auto Brake",
          setting: "Off",
        },
        {
          item: "Ground Spoilers",
          setting: "Retract",
        },
        {
          item: "Flaps",
          setting: "Retract",
        },
        {
          item: "Weather Radar",
          setting: "Off",
        },
        {
          item: "Predictive Windshear",
          setting: "Off",
        },
        {
          item: "TCAS",
          setting: "Stby",
        },
      ],
    },
    {
      title: "Parking / Shutdown",
      roles: ["parking", "shutdown"],
      content: [
        {
          item: "Parking Brake",
          setting: "Set",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "Off",
        },
        {
          item: "Nose Lights",
          setting: "Off",
        },
        {
          item: "APU",
          setting: "As Req / Start",
        },
        {
          item: "APU Bleed",
          setting: "As Req / On",
        },
        {
          item: "Engine Master 1 & 2",
          setting: "Off",
        },
        {
          item: "Passenger Signs",
          setting: "Off",
        },
        {
          item: "Beacon",
          setting: "Off",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "Off",
        },
        {
          item: "Fuel Pumps",
          setting: "Off",
        },
        {
          item: "Transponder",
          setting: "Stby",
        },
      ],
    },
    {
      title: "Securing the Aircraft",
      roles: ["securing"],
      content: [
        {
          item: "Parking Brake",
          setting: "As Req",
        },
        {
          item: "Oxygen Crew Supply",
          setting: "Off",
        },
        {
          item: "ADIRS",
          setting: "Off",
        },
        {
          item: "Exterior Lights",
          setting: "Off",
        },
        {
          item: "APU Bleed",
          setting: "Off",
        },
        {
          item: "APU Master",
          setting: "Off",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Off",
        },
        {
          item: "Passenger Signs",
          setting: "Off",
        },
        {
          item: "External Power",
          setting: "As Req",
        },
        {
          item: "Battery 1 / 2",
          setting: "Off",
        },
        {
          item: "APU Battery",
          setting: "Off",
        },
      ],
    },
  ],
};
